import React, { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import {
    PopUpText,
    ButtonFooter,
    SessionOutPopUpDiv,
    PopUpTitleText,
    PopUpTitleSubText1,
} from './ConfirmationPopUp.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import {
    hideScrolling,
    isMobileDevice,
    preventBouncingEffect,
    resumeScrolling,
    revertBouncingEffect,
    logErrorToConsole,
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging'; 

const ConfirmationPopUp = ({ onClose, confirmationMessage = [] }) => {
    const [hidePopup, setHidePopup] = useState(false);
    let confirmObj =
        confirmationMessage && confirmationMessage.length > 0
            ? confirmationMessage[0]
            : {};
    useEffectWithErrorLogging(() => {
        setHidePopup(false);
        hideScrolling();
        preventBouncingEffect();
        document.body.style.overflow = 'hidden';
        const htmlElement = document.getElementsByTagName('html');
        if (htmlElement && htmlElement[0]) {
            htmlElement[0].style.height = '100vh';
        }
        return () => {
            document.body.style.overflow = '';
            if (htmlElement && htmlElement[0]) {
                htmlElement[0].style.height = '';
            }
            resumeScrolling();
            setHidePopup(false);
            revertBouncingEffect();
        };
    }, []);
    const getFormattedMessage = (message) => {
        let text = '';
        text = message?.replaceAll('&nbsp;', ' ');
        text = text?.replaceAll('&quot;', '"');
        text = text?.replaceAll('<a', '<a target="_blank"');
        return text;
    };
    const handleOnClose = () => {
        setHidePopup(!confirmationMessage.length>0);
        onClose();
    };
    if (hidePopup) {
        return null;
    }
    const { t } = useTranslation();
    return (
        <div
            onBlur={resumeScrolling}
            onFocus={hideScrolling}
            onPointerMove={resumeScrolling}
            onTouchMove={resumeScrolling}
            onTouchEnd={hideScrolling}
        >
            <Popup
                onClose={() => {
                    try {
                        handleOnClose();
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
                title={confirmObj?.title}
                width={'80%'}
                webWidth={'80%'}
                textAlign={'start'}
                mobileWidth
                id={'common-confirmation-popup-close-button-popup'}
            >
                <SessionOutPopUpDiv>
                    <PopUpText
                        flexGrow={'1'}
                        height={isMobileDevice() ? 'auto' : 'auto'}
                        maxHeight={isMobileDevice() ? '40vh' : 'auto'}
                        font={'14px Avenir Next World'}
                        lineHeight={'20px'}
                        scrollBarWidth={'7px'}
                        scrollBarBorderRadius={'25px'}
                        scrollbarTrackMargin={'2px 0 81px 0'}
                        scrollBarBackgroundColor={'#808080'}
                        scrollBarBackGroundColorOnHover={'#00000029'}
                        mobileDeviceScrollBarDisplay={'block'}
                        mediumDeviceScrollBarDisplay={'block'}
                    >
                        {confirmObj?.urgentText ? (
                            <>
                                <PopUpTitleText>
                                    {confirmObj.urgentText}
                                </PopUpTitleText>
                                <br />
                            </>
                        ) : null}
                        <PopUpTitleSubText1>
                            {' '}
                            {ReactHtmlParser(
                                getFormattedMessage(confirmObj.descriptionText)
                            )}
                        </PopUpTitleSubText1>
                    </PopUpText>
                    <ButtonFooter>
                        <Button
                        id={'common-confirmation-popup-close-button'}
                            show={true}
                            width={'100px'}
                            height={'38px'}
                            //primary={true}
                            variant={ButtonStyles.primary}
                            // borderRadius={'19px'}
                            margin={'5px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={handleOnClose}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {t('common.closeButton')}
                            </div>
                        </Button>
                    </ButtonFooter>
                </SessionOutPopUpDiv>
            </Popup>
        </div>
    );
};

export default ConfirmationPopUp;
